var _rect, _path, _rect2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartialCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "#FFC600"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7H10",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "#FFC600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.046 7.2H6.11V9H5.582V4.8H7.046C7.832 4.8 8.294 5.262 8.294 6C8.294 6.738 7.832 7.2 7.046 7.2ZM6.11 6.696H7.076C7.508 6.696 7.748 6.45 7.748 6C7.748 5.55 7.508 5.304 7.076 5.304H6.11V6.696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialCircle);
export default __webpack_public_path__ + "static/media/partial_circle.f583784c327e182dbe91423394f1e386.svg";
export { ForwardRef as ReactComponent };